import loadable from '@loadable/component';
import { LOADABLE_NO_SSR } from 'shared/utils/loadable';

export const ChatsContainerLoadable = loadable(
  () => import('./ChatsContainer').catch(/* istanbul ignore next */ () => ({ default: () => null })),
  { ...LOADABLE_NO_SSR },
);
ChatsContainerLoadable.displayName = 'ChatsContainerLoadable';
